import React from 'react';
import QuoteAction from './QuoteAction';

function LineAction(props) {
  return <QuoteAction {...props} />
}

export default LineAction;
